import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getPayrollSchedules = options =>
  call(websocketFetch, 'get_payroll_schedules', options);
